import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { options } from './constants'

const TypeSelector = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      value={value}
      label={t('Modo de filtrado')}
      handleChange={e => onChange(e.target.value)}
      menuItems={options.map(option => ({
        label: t(option.label),
        value: option.value,
      }))}
      disabled={disabled}
    />
  )
}

export default TypeSelector
